import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_7: FaireProductEntity = {
  token: "legacy_prod_abbott-7",
  type: "product",
  name: "Green LED Pillar Candle 3x8 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/1d411e89e79384cf5664dd45fbbc13bbbd4b005dc981277957a524cc9d6e1f4b.jpeg",
  priceDollars: 10,
  msrpDollars: 20,
  subcategory: "Pillar Candles",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_candles-holders"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
